const doc = [({"en":({"js":({"confirm_dialog":({"ok":"OK", "cancel":"Cancel", "confirm":"Confirm"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;